module.exports = __webpack_public_path__ + "img/banner-eseminar.551f9d9.webp";